import { BaseAPI } from '@emfit/shared-store';
import { Storage } from 'src/storage';
import { isTokenExpired } from './jwt';

/**
 * Unauthorized handler. Clears session data (token, userData) but keeps
 * user preferences so they survive across login/logout cycles.
 */
function handleUnauthorized(error?: Error) {
  console.error(
    'API unauthorized - clearing tokens and redirecting to login',
    error
  );
  console.trace('Stack trace for unauthorized call:');
  Storage.remove('token');
  Storage.remove('userData');
  window.location.href = '/';
}

/**
 * WORKAROUND(orguard-403): care-api answers 403 instead of 401 for an expired
 * token on routes guarded by OrGuard. A 403 with an expired token is a dead
 * session; a 403 with a live token is a real permission error and stays one.
 */
export function isExpiredSessionResponse(response: Response): boolean {
  return response.status === 403 && isTokenExpired(Storage.get('token'));
}

/**
 * API client. care-api reads the token from the Accesstoken header.
 */
const EmfitAPI = new BaseAPI({
  origin: 'https://care-api.emfit.com',
  getAdditionalHeaders: () => ({
    Accesstoken: `Bearer ${Storage.get('token')}`,
  }),
  onUnauthorized: handleUnauthorized,
  isUnauthorized: isExpiredSessionResponse,
});

export { EmfitAPI };
export default BaseAPI;
